// 提供abtest服务

import storage from 'root/common/util/storage';
import fetchABTestIfNeed, { fetchABTestH5IfNeed } from './request';
import abTestFlagJson from './constant';
import urlUtil from 'root/common/util/url';
import { compareVersion, getAppVersion } from '../util/getAppVersion';
import env from '../util/env';
import syncCall from '../nativeApi/syncApi';
import { setGioVisitorForABTest } from 'root/common/gio/peopleVar';

// 特定马甲包
const isAppVest = /knightcard_vest/.test(window.navigator.userAgent.toLowerCase());
// 大于2.14.0的app使用原生同步插件传递的abtest qie
const useNativeABtest = env.isApp && !isAppVest && compareVersion(getAppVersion(), '2.14.0') >= 0;

// 大于2.14.0的app使用原生同步插件传递的abtest
// const useNativeABtest = env.isApp && compareVersion(getAppVersion(), '2.14.0') >= 0;

let abTest = null;
let abTestSync = null; // 防止ab接口多次调用

if (useNativeABtest) {
    try {
        abTest = syncCall('getABTestJson');
        abTestSync = abTest;
        // 写入本地
        const data = Object.entries(abTest).reduce((p, [key, ab]) => {
            p[key] = { abTest: ab };
            return p;
        }, {});
        storage.set(storage.keys.abtest, { data, time: Date.now() });
        // abtest相关gio用户变量
        setGioVisitorForABTest(data);
    } catch (e) {
        if (window.monitor) {
            window.monitor.report({
                level: 'info',
                error: 'nativeApi',
                url: window.location.href,
                msg: e.message,
                stack: e.stack.slice(0, 300),
            });
        }
    }
}

// 从url上解析abTest，为了解决原生与h5的abtest同步问题，所以优先级最高
const queryAbTest = {};
const queryAbTestText = urlUtil.getQuery().abTestJson;
if (queryAbTestText && !useNativeABtest) {
    try {
        const q = JSON.parse(queryAbTestText);
        Object.assign(queryAbTest, q);
    } catch (error) {
        console.error(error);
    }
}

/**
 * 判断某个key是否为A桶
 * @param {string} key
 */
export function isA(key) {
    return getABTest(key) === 'A';
}

/**
 * 判断某个key是否为B桶
 * @param {string} key
 */
export function isB(key) {
    return getABTest(key) === 'B';
}

export function getAllAB() {
    if (abTest) {
        return abTest;
    }
    fetchABTestIfNeed();
    const obj = storage.get(storage.keys.abtest);
    if (!obj) {
        abTest = { ...abTestFlagJson };
    } else {
        abTest = obj.data
            ? Object.entries(obj.data).reduce(
                  (o, [key, i]) => {
                      o[key] = i.abTest;
                      return o;
                  },
                  { ...abTestFlagJson }
              )
            : { ...abTestFlagJson };
    }

    Object.assign(abTest, queryAbTest);
    return abTest;
}

export function abTestJson() {
    return JSON.stringify(getAllAB());
}

/**
 * 判断某个key是否为B桶 同步
 * @param {string} key
 */
export async function getAllABSync(timeout) {
    if (abTestSync) return abTestSync;
    await fetchABTestIfNeed(timeout);
    const ab = storage.get(storage.keys.abtest);
    let abTest = (ab && ab.data) || {};
    abTestSync = Object.entries(abTest).reduce(
        (o, [key, i]) => {
            o[key] = i.abTest;
            return o;
        },
        { ...abTestFlagJson }
    );
    return abTestSync;
}

export async function getAllH5ABSync(timeout) {
    await fetchABTestH5IfNeed(timeout);
    const ab = storage.get(storage.keys.h5Abtest);
    let abTest = (ab && ab.data) || {};
    const abTestSync = Object.entries(abTest).reduce(
        (o, [key, i]) => {
            o[key] = i.abTest;
            return o;
        },
        { ...abTestFlagJson }
    );
    return abTestSync;
}

/**
 * 获取某个abtest的值
 * @param {string}
 */
export default function getABTest(key) {
    const abTestObj = getAllAB();
    return abTestObj[key] || 'A';
}

/**
 * 获取某个abtest的值 同步
 * @param {string} key
 * @param {number} timeout 毫秒，如果上一次调接口没超过这个期限，则不调接口了
 */
export async function getABTestSync(key, timeout) {
    const abTestObj = await getAllABSync(timeout);
    const abTest = abTestObj[key];
    return abTest || 'A';
}

/**
 * 获取某个h5abtest的值 同步
 * @param {string} key
 * @param {number} timeout 毫秒，如果上一次调接口没超过这个期限，则不调接口了
 */
export async function getH5ABTestSync(key, timeout) {
    const abTestObj = await getAllH5ABSync(timeout);
    const abTest = abTestObj[key];
    return abTest || 'A';
}

/**
 * 获取原生abtest的值
 * @param {string} key
 */
export function getNativeABTest(key) {
    if (abTestSync) {
        return abTestSync[key];
    }
}

/**
 * 获取abtest的值
 * getABTest有暇疵
 * 如果本地没有缓存的数据，或者缓存的数据需要更新，getABTest取到的值可能与getABTestSync不一致
 */
export function getABTestAsync(key) {
    return (abTestSync && abTestSync[key]) || getABTest(key);
}
